import React, { useEffect } from 'react';
import { useState,FC } from 'react';
import Header from './components/Header'
import './App.css';
import Home from './components/Home';
import { BrowserRouter as Router,Route,Routes} from "react-router-dom";
import Error from './components/Error';
import Help from './components/Help';
import Map from './components/Map';
import TopPage from './components/TopPage';
import Plan from './components/Plan';






export const App : FC=() =>{
 return(
  <Router>
   <div className='App'>
   <Header />
    <Routes>
      <Route path="*" element={<Error />} />
      <Route path="/" element={<TopPage />}/>
      <Route path="/Post" element={<Home />}/>
      <Route path="/Map" element={<Map/>}/>
      <Route path="/Plan" element={<Plan/>}/>
      <Route path="/Help" element={<Help />}/>
    </Routes>
   </div>
  </Router>
 )
}

export default App;
